import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

export const InfoTooltip = ({ tooltipText, className }) => {
  return (
    <Tooltip
      arrow
      placment="left-start"
      title={
        <Typography variant="body2" color="inherit">
          {tooltipText}
        </Typography>
      }
      className={className}
    >
      <InfoOutlined />
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  tooltipText: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default InfoTooltip;
